import { db } from "./firebase"
import userService from "./user-service"

export default {
  projectsRef() {
    return db.ref("projects")
  },

  projectRef(projectId) {
    return this.projectsRef().child(projectId)
  },

  projectNameRef(projectId) {
    return this.projectRef(projectId).child("name")
  },

  projectDataRef(projectId) {
    return this.projectRef(projectId).child("data")
  },

  projectCurrencyRef(projectId) {
    return this.projectDataRef(projectId).child("currency")
  },

  projectRestApiRef(projectId) {
    return this.projectDataRef(projectId).child("restApi")
  },

  projectDefaultImageRef(projectId) {
    return this.projectDataRef(projectId).child("defaultImage")
  },
  getDemoProjectData() {
    return this.projectDataRef("DEMO")
      .once("value")
      .then(snapshot => snapshot.val())
  },
  async createProject(projectName, email, currency, isDemo) {
    const key = this.projectsRef().push().key
    const project = {
      id: key,
      name: projectName,
      data: { currency },
      members: {
        [userService.escapeEmail(email)]: {
          role: "admin"
        }
      }
    }
    await this.projectRef(key).set(project)
    if (isDemo) {
      const projectData = await this.getDemoProjectData()
      await this.projectDataRef(key).set(projectData)
      project.data = projectData
    }
    return project
  },

  async setProjectName(projectId, projectName) {
    await this.projectNameRef(projectId).set(projectName)
    return projectName
  },

  async setProjectCurrency(projectId, currency) {
    await this.projectCurrencyRef(projectId).set(currency)
    return currency
  },

  async setProjectRestApi(projectId, restApi) {
    await this.projectRestApiRef(projectId).set(restApi)
    return restApi
  },

  async setProjectDefaultImage(projectId, defaultImage) {
    await this.projectDefaultImageRef(projectId).set(defaultImage)
    return defaultImage
  },

  getRestApiUrl(projectId) {
    return db.app.options.databaseURL + "/projects/" + projectId + "/data/"
  },

  removeProject(projectId) {
    return this.projectsRef().update({
      [projectId]: null
    })
  },

  onProjectNameChanged(projectId, callback, errorCallback) {
    this.projectNameRef(projectId).on(
      "value",
      snapshot => {
        const name = snapshot.val()
        callback(name)
      },
      errorCallback
    )
  },

  onProjectCurrencyChanged(projectId, callback, errorCallback) {
    this.projectCurrencyRef(projectId).on(
      "value",
      snapshot => {
        const currency = snapshot.val()
        callback(currency)
      },
      errorCallback
    )
  },

  onProjectRestApiChanged(projectId, callback, errorCallback) {
    this.projectRestApiRef(projectId).on(
      "value",
      snapshot => {
        const restApi = snapshot.val() || {}
        callback(restApi)
      },
      errorCallback
    )
  },

  onProjectDefaultImageChanged(projectId, callback, errorCallback) {
    this.projectDefaultImageRef(projectId).on(
      "value",
      snapshot => {
        const defaultImage = snapshot.val()
        callback(defaultImage)
      },
      errorCallback
    )
  },

  offProjectNameChanged(projectId) {
    this.projectNameRef(projectId).off()
  },

  offProjectCurrencyChanged(projectId) {
    this.projectCurrencyRef(projectId).off()
  },

  offProjectRestApiChanged(projectId) {
    this.projectRestApiRef(projectId).off()
  },

  offProjectDefaultImageChanged(projectId) {
    this.projectDefaultImageRef(projectId).off()
  }
}
